import { render, staticRenderFns } from "./CompanyOmbudsman.vue?vue&type=template&id=618b0ca6&"
import script from "./CompanyOmbudsman.vue?vue&type=script&lang=js&"
export * from "./CompanyOmbudsman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports